import { useState } from 'react';
import { Globe } from 'lucide-react';
import type { Source } from '@medicail/shared';
import { faviconUrl, hostname } from '@/lib/format';

function Favicon({ url }: { url: string }) {
  const [failed, setFailed] = useState(false);
  if (failed) return <Globe className="size-4 shrink-0 text-ink-muted" aria-hidden="true" />;
  return (
    <img
      src={faviconUrl(url)}
      alt=""
      width={16}
      height={16}
      loading="lazy"
      referrerPolicy="no-referrer"
      onError={() => setFailed(true)}
      className="size-4 shrink-0 rounded-[4px]"
    />
  );
}

export function Sources({ sources }: { sources: Source[] }) {
  if (!sources.length) return null;
  return (
    <section aria-label="Sources" className="mt-4">
      <h3 className="mb-2 text-xs font-medium uppercase tracking-wide text-ink-muted">Sources</h3>
      <ul className="flex flex-wrap gap-2">
        {sources.map((s) => (
          <li key={s.url} className="min-w-0 max-w-full">
            <a
              href={s.url}
              target="_blank"
              rel="noopener noreferrer"
              title={s.snippet ? `${s.title}: ${s.snippet}` : s.title}
              className="group flex max-w-full items-center gap-2.5 rounded-xl border border-line bg-surface px-3 py-2 shadow-sm transition hover:-translate-y-px hover:border-royal-300 hover:shadow-soft sm:max-w-[16rem]"
            >
              <Favicon url={s.url} />
              <span className="min-w-0">
                <span className="block truncate text-[0.8rem] font-medium leading-tight text-ink">{s.title || hostname(s.url)}</span>
                <span className="block truncate text-xs text-ink-muted">{hostname(s.url)}</span>
              </span>
            </a>
          </li>
        ))}
      </ul>
    </section>
  );
}
